import { DocumentTypeCode } from '@/apiClient';

import noAnimal from '@/components/viewAnimal/profile/noAnimal.svg';

import { DocumentImage } from '@/primitives';

export interface AnimalAvatarProps {
  animalEntityId?: string;
  height: number;
  width: number;
}

export function AnimalAvatar({
  animalEntityId,
  height,
  width,
}: AnimalAvatarProps) {
  return (
    <DocumentImage
      alt="Animal avatar"
      documentTypeCode={DocumentTypeCode.Avatar}
      documentEntityId={animalEntityId || ''}
      fallbackImage={noAnimal}
      height={height}
      width={width}
      sx={{ borderRadius: '50%', '&.fallback': { overflow: 'visible' } }}
    />
  );
}
